import { useMemo } from 'react';
import { isBrowser, setBlueHost } from '@belong/env';

export const useBlueGreen = (host: string) => {
  useMemo(() => {
    setBlueHost(isBrowser() ? window.location.host : host);
  }, [host]);
};
